import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from "@angular/router";
import { CriticaRegistroBoletoComponent } from './critica-registro-boleto.component';
import { MatButtonModule, MatDatepickerModule, MatFormFieldModule, MatInputModule, MatTableModule } from "@angular/material";
import { FuseSharedModule } from "@fuse/shared.module";
import { Ng4LoadingSpinnerModule } from "ng4-loading-spinner";
import { NgxLoadingModule } from "ngx-loading";
import { SharedModule } from "../shared/shared.module";
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatPaginatorModule } from '@angular/material';

const routes = [
    {
        path: 'critica-registro-boleto',
        component: CriticaRegistroBoletoComponent
    }
];


@NgModule({
  declarations: [CriticaRegistroBoletoComponent],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    SharedModule,
    Ng4LoadingSpinnerModule,
    MatButtonModule,
    FuseSharedModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatTooltipModule,
    MatTableModule,
    MatPaginatorModule,
  
    NgxLoadingModule.forRoot({ fullScreenBackdrop: true }),
  ],
  exports: [CriticaRegistroBoletoComponent]
})
export class CriticaRegistroBoletoModule { }
